import type { Components, Theme } from '@mui/material'

type MuiTooltipSettings = Components<Omit<Theme, 'components'>>['MuiTooltip']

export const MuiTooltip: MuiTooltipSettings = {
  defaultProps: {
    slotProps: {
      popper: {
        // This change the default distance of the tooltip from the anchor element
        modifiers: [{ name: 'offset', options: { offset: [0, -12] } }],
      },
    },
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      padding: '8px 12px',
      fontWeight: 600,
      fontSize: 12,
      lineHeight: 1.5,
      borderRadius: 8,
      color: theme.palette.grey[800],
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.grey[200]}`,
    }),
  },
}
